namespace advisorop.components.advisor {

  class CuAdvisorController {

    $router;
    onAdvisorLoaded: any;
    lovs: Array<domains.ILOV> = [];
    public model: domains.IAdvisor;
    user: domains.identity.IUser;
    currentAdvisor: domains.IAdvisor;
    companyGroupSelected: any;
    selAdvisorRole: domains.identity.IRole;
    advisoryFirms: Array<domains.IAdvisoryFirm> = [];
    advisorCustodians: Array<domains.IAdvisorCustodian> = [];
    deletedAdvisorCustodians: Array<domains.IAdvisorCustodian> = [];
    advisorManagers: Array<domains.IAdvisorManager> = [];
    deletedAdvisorManagers: Array<domains.IAdvisorManager> = [];

    advisor: domains.IAdvisor;
    advisory: domains.IAdvisor;
    roles: Array<domains.identity.IRole>;
    // allRoles: Array<domains.identity.IRole>;
    advisoryFirmsRelatedForCompGroup: Array<domains.IAdvisoryFirm> = [];
    onClearCompanyGroup: any;
    selAdvisoryFirm: domains.IAdvisoryFirm;
    companyList: Array<domains.ICompanyGroup> = [];
    companyGroup: domains.ICompanyGroup;
    servicer: any;
    loadedRole: string;
    selCompanyGroup: domains.ICompanyGroup;
    loadedCompanyGroup: domains.ICompanyGroup;
    companyGroupId: number;
    loadedAdvisoryFirms: Array<domains.IAdvisoryFirm> = [];
    flagForDisableForm: boolean = false;

    advisoryAdmin: any;
    advisoryLead: any;
    advisoryRole: any;
    updatingAccountLadda: boolean = false;

    selectedAdvisor: domains.IAdvisor;
    extAdvisorId: number;
    contactEmailError: string = null;
    streetAddressSameAsMailingAddress: boolean = false;
    flagForZipField: boolean = false;

    states: domains.ILOV[] = [];
    countries: domains.ILOV[] = [];
    usCountryCode: string = "US";
    selStreetState: domains.ILOV;
    selMailingState: domains.ILOV;
    selStreetCountry: domains.ILOV;
    selMailingCountry: domains.ILOV;


      static $inject = ["identityService", "servicerService", "advisorService", "generalService", "advisoryFirmApi"];
    constructor(private ids: services.IdentityService,
        private ss: services.ServicerService,
        private ads: services.AdvisorService,
        private gs: services.GeneralService,
        private advisoryFirmApi: services.AdvisoryFirmApi
    ) {
        this.model = {
            useEmailAsUsername: true
        };

      this.servicer = domains.SystemLoginType.SERVICER;
      this.advisoryAdmin = domains.AdvisoryRoles.ADVISORY_ADMIN.toString();
      this.advisoryLead = domains.AdvisoryRoles.ADVISORY_LEAD.toString();
      this.advisoryRole = domains.AdvisoryRoles.ADVISORY.toString();
    }

    selectedCompanyGroup(advisorFirm: domains.ICompanyGroup) {
      this.companyGroup = advisorFirm;
    }

    /// The address becomes the advisor's login name and is where the activation email goes, so it
    /// is checked against ContactValidator - the browser-side mirror of ContactValidation, which
    /// the server applies - rather than a regex of this screen's own. That means everything RFC
    /// 5322 allows before the @ is accepted, "+" included.
    contactEmailChanged(): void {
      this.contactEmailError = this.model.contactEmail
        ? domains.identity.ContactValidator.email(this.model.contactEmail)
        : null;
    }

    showLeadsCombo: boolean;

    advisoryRoleChanged(): void {
      if (this.selAdvisorRole)
        this.model.advisorRole = this.selAdvisorRole.name;
      if (this.selAdvisorRole.name != this.advisoryAdmin)
        this.showLeadsCombo = true;
      if (this.selAdvisorRole.name != this.advisoryAdmin && this.selCompanyGroup) {
        this.showLeadsCombo = true;
        this.loadAdvisoryLeads(this.selCompanyGroup.id);
      }
      else {
        this.showLeadsCombo = false;
        this.selAdvisoryLead = {};
      }
    }

    clearCompanyGroup(): void {
      var advFirm: domains.ICompanyGroup = {};
      this.onClearCompanyGroup();
    }

    validateAdvisorData(): boolean {
      if (!this.model.tin || this.model.tin.length != 9) {
        toastr.warning("Please provide 9-digit Tax ID Number.");
        return false;
      }
      if (isNaN(Number(this.model.tin))) {
        toastr.warning("Tax ID Number must consist of all numbers.");
        return false;
      }
      // Also checked here, not only as the field is typed into: it can be left untouched
      // altogether, and an advisor saved without a usable address gets no login at all.
      var contactEmailError = domains.identity.ContactValidator.email(this.model.contactEmail);
      if (contactEmailError) {
        this.contactEmailError = contactEmailError;
        toastr.warning(contactEmailError);
        return false;
      }
      if (!this.model.contactPhone || this.model.contactPhone.length != 10) {
        toastr.warning("Please provide 10-digit phone number.");
        return false;
      }
      if (isNaN(Number(this.model.contactPhone))) {
        toastr.warning("Phone number must consist of all numbers.");
        return false;
      }
      if (!this.advisorCustodianValid()) {
        toastr.warning("You must select advisory firm for each custodian");
        return false;
      }
      if (this.advisorCustodianDuplicates()) {
        toastr.warning("There cannot be duplicate combination of custodian and advisory firm in custodians");
        return false;
      } if (!this.advisorManagerValid()) {
        toastr.warning("You must select advisory firm for each manager");
        return false;
      }
      if (this.advisorManagerDuplicates()) {
        toastr.warning("There cannot be duplicate combination of manager and advisory firm in managers");
        return false;
      }

      if (!this.selAdvisorRole) {
        toastr.warning(`Please select advisory role`);
        return false;
      }

      if (!this.selAdvisoryLead && this.selAdvisorRole.name != this.advisoryAdmin) {
        toastr.warning("Please select advisory lead.");
        return false;
      }

      // checks from Servicer perspective
      if (this.user.systemLoginType === domains.SystemLoginType.SERVICER) {

        if (this.advisoryFirms.length < 1) {
          toastr.warning(`Please provide at least one advisory firm for this advisor.`);
          return false;
        }

      }

      return true;
    };

    //validateAdvisorForm(): boolean {
    //    var frm = <ng.IFormController>this.$scope["frmAdvisor"];
    //    //console.log(frm);            
    //    if (frm.$invalid) {
    //        for (var el in frm) {
    //            if (el.indexOf("$") < 0) {
    //                frm[el].$setTouched();
    //            }
    //        }
    //        return false;
    //    }
    //    return true;
    //};

    selAdvisoryLead: domains.IAdvisor;

    createAdvisor(): void {
      this.model.advisoryFirms = this.advisoryFirms;
      this.model.streetAddressSameAsMailingAddress = this.streetAddressSameAsMailingAddress;

      if (!this.validateAdvisorData()) {
        return;
      }

      this.updatingAccountLadda = true;
      
      if (this.user.systemLoginType == domains.SystemLoginType.ADVISOR) {
        this.model.companyGroup = this.currentAdvisor.companyGroup;
        this.model.selectedAdvisoryLeadId = this.selAdvisoryLead.id;

        this.ads.createAdvisor(this.model)
            .then(response => {
                if (response.data.warnings && response.data.warnings.length) {
                    toastr.warning(`Advisor successfully created with warnings`);
                    for (var i = 0; i < response.data.warnings.length; i++) {
                        toastr.warning(response.data.warnings[i]);
                    }
                } else {
                    toastr.success("Advisor successfully created.");
                }
            }, err => {
                toastr.error("Advisor was not registered! " + err.status + " : " + err.data);
        })
        .finally(() => {
            this.updatingAccountLadda = false;
            //this.$router.navigate(["Dashboard"]);
        });
      }
      else if (this.user.systemLoginType == domains.SystemLoginType.SERVICER) {
        if (this.selAdvisorRole.name != this.advisoryAdmin)
          this.model.selectedAdvisoryLeadId = this.selAdvisoryLead.id;

        this.model.advisoryFirms = this.advisoryFirms;
        this.model.companyGroup = this.selCompanyGroup;
        this.model.advisorCustodians = this.advisorCustodians;
        this.model.advisorManagers = this.advisorManagers;
        this.ss.createAdvisor(this.model)
          .then(response => {
              if (response.data.warnings && response.data.warnings.length) {
                  toastr.warning(`Advisor successfully created with warnings`);
                  for (var i = 0; i < response.data.warnings.length; i++) {
                      toastr.warning(response.data.warnings[i]);
                  }
              } else {
                  toastr.success("Advisor successfully created.");
              }
          })
          .catch(err => {

            toastr.error("Advisor was not created! " + err.status + " : " + err.data);
          })
          .finally(() => {
            this.updatingAccountLadda = false;
            this.$router.navigate(["Dashboard"]);
          });
      }
    }



    updateAdvisor(): void {

        
        if (this.user.systemLoginType == domains.SystemLoginType.SERVICER) {
            // this needs to be changed, we need compare IDs not references
            if (this.model.companyGroup != this.selCompanyGroup) {
                if (!confirm("Would you realy like to change company group for " + this.model.fullName + " advisor ?"))
                    return;
            }
        } else {
            this.model.companyGroup = this.currentAdvisor.companyGroup;
            this.selCompanyGroup = this.currentAdvisor.companyGroup;
        }

      this.model.advisoryFirms = this.advisoryFirms;
      this.model.advisorCustodians = this.advisorCustodians.concat(this.deletedAdvisorCustodians);//merge arrays
      this.deletedAdvisorCustodians.splice(0, this.deletedAdvisorCustodians.length);
      this.model.advisorManagers = this.advisorManagers.concat(this.deletedAdvisorManagers);//merge arrays
      this.deletedAdvisorManagers.splice(0, this.deletedAdvisorManagers.length);
      this.model.streetAddressSameAsMailingAddress = this.streetAddressSameAsMailingAddress;

      // CRM mappings are managed via separate API — don't send them with advisor update
      this.model.advisorCrms = null;
      
      if (!this.validateAdvisorData()) {
        return;
      }

        if (this.selAdvisoryLead && this.selAdvisorRole.name != this.advisoryAdmin) {
            this.model.selectedAdvisoryLeadId = this.selAdvisoryLead.id;
        }

      this.updatingAccountLadda = true;

        if (this.user.role == domains.AdvisoryRoles.ADVISORY_LEAD.toString()
            || this.user.role == domains.AdvisoryRoles.ADVISORY_ADMIN.toString()) {

            this.model.companyGroup = this.currentAdvisor.companyGroup;
            this.ads.updateAdvisor(this.model)
                .then((data) => {
                    toastr.success("Advisor successfully updated.");
                    // api returns Id of advisor not whole object
                    // this.mapModel(data.data as domains.IAdvisor);
                    this.advisor.id = data.data;
                }, err => this.gs.showError(err))
                .finally(() => {
                    this.updatingAccountLadda = false;
                    //this.$router.navigate(["Dashboard"]);
                });
        }
      else if (this.user.role == domains.AdvisoryRoles.SERVICER_ADMIN.toString()) {

        if (this.selAdvisorRole.name != this.advisoryAdmin && this.selAdvisoryLead) {
          this.model.selectedAdvisoryLeadId = this.selAdvisoryLead.id;
        }

        this.model.companyGroup = this.selCompanyGroup;
        // console.log("advisorModel", this.model);
        this.ss.updateAdvisor(this.model)
          .then((data) => {
            toastr.success("Advisor successfully updated.");
            this.mapModel(data.data as domains.IAdvisor);
          })
          .catch(err => {

            toastr.error("Advisor was not updated! " + err.status + " : " + err.data);
          })
          .finally(() => {
            this.updatingAccountLadda = false;
            this.$router.navigate(["Dashboard"]);
          });
      }
    };

    advisorCustodianDuplicates(): boolean {
      for (var i = 0; i < this.advisorCustodians.length; i++) {

        var advcust = this.advisorCustodians.filter((v, index, a) => {
          return v.advisoryFirmId == this.advisorCustodians[i].advisoryFirmId && v.custodianId == this.advisorCustodians[i].custodianId && index != i;
        });

        if (advcust.length > 0)//postoji duplikat
          return true;
      }

      return false;
    }

    advisorCustodianValid(): boolean {
      // console.log("advisorCustodians", this.advisorCustodians);
      angular.forEach(this.advisorCustodians, function (ac, ind) {
        if (ac == null || ac.advisoryFirm == null)
          return false;
        ac.advisoryFirmId = ac.advisoryFirm.id;
      });

      var adv = this.advisorCustodians.filter((v, i, a) => {
        return v.advisoryFirmId == null || v.advisoryFirmId == 0;
      });
      if (adv.length > 0) {
        return false;
      }
      return true;

    }

    advisorManagerDuplicates(): boolean {
      for (var i = 0; i < this.advisorManagers.length; i++) {

        var advmgr = this.advisorManagers.filter((v, index, a) => {
          return v.advisoryFirmId == this.advisorManagers[i].advisoryFirmId && v.managerId == this.advisorManagers[i].managerId && index != i;
        });

        if (advmgr.length > 0)//postoji duplikat
          return true;
      }

      return false;
    }

    advisorManagerValid(): boolean {
      // console.log("advisorManagers", this.advisorManagers);
      angular.forEach(this.advisorManagers, function (ac, ind) {
        if (ac == null)
          return false;
        ac.advisoryFirmId = ac.advisoryFirm.id;
      });

      var adv = this.advisorManagers.filter((v, i, a) => {
        return v.advisoryFirmId == null || v.advisoryFirmId == 0;
      });
      if (adv.length > 0) {
        return false;
      }
      return true;

    }


    newAdvisoryFirmSelected(advisoryFirm: domains.IAdvisoryFirm): void {
      var adv = this.advisoryFirms.filter((v, i, a) => {
        return v.id == advisoryFirm.id;
      });
      if (adv.length === 0)
        this.advisoryFirms.push(advisoryFirm);
      else
        toastr.warning("Advisory firm already exists in the list of advisory firms.");
    };


    removeAdvisoryFirm(inv: domains.IAdvisoryFirm): void {
      var adv = this.advisoryFirms.indexOf(inv);
      if (adv >= 0)
        this.advisoryFirms.splice(adv, 1);

    };

    //foundRole: domains.identity.IRole;

    //searchrole(roleName: string): void {
    //  this.foundRole = this.allRoles.filter((v) => { return v.name.match(roleName); })[0];
    //  this.selAdvisorRole = this.foundRole;
    //}

    newCustodianSelected(custodian: domains.ICustodian): void {
      var newAdvCust: domains.IAdvisorCustodian = {
        id: 0,
        custodianId: custodian.id, advisorId: this.model.id, advisoryFirmId: 0, repId: "", custodian: custodian, advisoryFirm: null, status: domains.Status.ACTIVE
      };
      //console.log("NEW CUST ADDED", newAdvCust);
      this.advisorCustodians.push(newAdvCust);

      //if (cust.length === 0)
      //    this.advisorCustodians.push(newAdvCust);
      //else
      //    toastr.warning("Custodian already exists on the list of custodians!");

      // console.log("this.advisorCustodians", this.advisorCustodians);
    }

    removeCustodian(advisorCustodian: domains.IAdvisorCustodian): void {

      let promise: ng.IHttpPromise<any>;
      if (this.user.systemLoginType == domains.SystemLoginType.ADVISOR) {
        promise = this.ads.removeAdvisorRepId(advisorCustodian.id);
      }
      else if (this.user.systemLoginType == domains.SystemLoginType.SERVICER) {
        promise = this.ss.removeAdvisorRepId(advisorCustodian.id);
      }
      else {
        toastr.error(`Operation not allowed`);
        return;
      }

      promise.then(data => {
        toastr.success("Rep ID has been successfully removed");
        var cust = this.advisorCustodians.indexOf(advisorCustodian);
        if (cust >= 0)
          this.advisorCustodians.splice(cust, 1);
      }, err => this.gs.showError(err));

    }

    saveCustodian(advisorCustodian: domains.IAdvisorCustodian): void {
      
      if (!advisorCustodian.advisoryFirm) {
        toastr.error("Please select Advisory Firm");
        return;
      }
      if (!advisorCustodian.repId || advisorCustodian.repId.length < 1) {
        toastr.error("Please select enter valid Rep ID longer than 1");
        return;
      }
      advisorCustodian.advisoryFirmId = advisorCustodian.advisoryFirm.id;

      let promise: ng.IHttpPromise<any>;

      if (this.user.systemLoginType == domains.SystemLoginType.ADVISOR) {
        promise = this.ads.setAdvisorRepId(advisorCustodian);
      }
      else if (this.user.systemLoginType == domains.SystemLoginType.SERVICER) {
        promise = this.ss.setAdvisorRepId(advisorCustodian);
      }
      else {
        toastr.error(`Operation not allowed`);
        return;
      }

      promise.then(data => {
        toastr.success("Rep ID has been successfully saved");
        advisorCustodian.id = data.data.id;
      }, err => this.gs.showError(err));
    }

    advisorCustodianChange(cust: domains.ICustodian): void {
      // console.log("custodian ", cust);
    }

    newManagerSelected(manager: domains.IManager): void {
      var newAdvMgr: domains.IAdvisorManager = { id: 0, managerId: manager.id, advisorId: this.model.id, advisoryFirmId: 0, repId: "", manager: manager, advisoryFirm: null, status: domains.Status.ACTIVE };
      this.advisorManagers.push(newAdvMgr);

      //if (mgr.length === 0)
      //    this.advisorManagers.push(newAdvMgr);
      //else
      //    toastr.warning("Manager already exists on the list of managers!");

      // console.log("this.advisorManagers", this.advisorManagers);
    }

    crmLinked(crm: any) {
      //console.log("$_crm", crm);
      if (crm.id === 0) {
        this.model.advisorCrms.push(crm);
      } else {
        this.model.advisorCrms.filter(x => x.id === crm.id)[0] = crm;
      }
      //console.log("$_model", this.model);
    }

    removeManager(advisorManager: domains.IAdvisorManager): void {
      // console.log(advisorManager);

      var mgr = this.advisorManagers.indexOf(advisorManager);
      if (mgr >= 0)
        this.advisorManagers.splice(mgr, 1);

      if (advisorManager.id > 0) {
        advisorManager.status = domains.RecordStatus.DELETED;//set status on inactive
        this.deletedAdvisorManagers.push(advisorManager)
      }
    }

    advisorManagerChange(mgr: domains.IManager): void {
      // console.log("manager ", mgr);
    }

    loadLovs(): void {
      this.gs.getLOVs()
        .then((data) => {
          this.lovs = data;
          this.states = this.lovs.filter(v => v.lovType === domains.LovType.STATES);
          this.countries = this.lovs.filter(v => v.lovType === domains.LovType.COUNTRIES && v.extra2 === this.usCountryCode)
            .concat(this.lovs.filter(v => v.lovType === domains.LovType.COUNTRIES && v.extra2 !== this.usCountryCode));
        }, (reason) => {
          toastr.error("Error " + reason);
        });
    };

    loadAdvisor(adv: number): void {
      this.ads.getAdvisorById(adv)
        .then(data => {
          this.advisor = data.data;
          //console.log("Advisor has been loaded...", this.advisor);
          this.onAdvisorLoaded({ advisor: this.advisor });
          this.mapModel(this.advisor);

          //this.model = this.advisor;

          //this.loadedRole = data.data.systemLogin.role;

          //this.searchrole(this.loadedRole);

          //if (this.user.role === domains.AdvisoryRoles.ADVISORY_LEAD.toString() && this.loadedRole != domains.AdvisoryRoles.ADVISORY.toString()) {
          //    this.getRolesFromIdUser(true);
          //    this.flagForDisableForm = true;
          //}

          //if (this.user.role === domains.AdvisoryRoles.ADVISORY_ADMIN.toString() && this.loadedRole != domains.AdvisoryRoles.ADVISORY_LEAD.toString()) {
          //    this.getRolesFromIdUser(true);
          //    this.flagForDisableForm = true;

          //}

          //this.selAdvisorRole = this.foundRole;

          //this.model.advisorRole = this.selAdvisorRole.name;

          //this.streetAddressSameAsMailingAddress = this.model.streetAddressSameAsMailingAddress;

          //this.model.companyGroup = data.data.companyGroup;
          //this.selCompanyGroup = data.data.companyGroup;
          //this.companyGroupId = this.selCompanyGroup.id;
          //this.loadedCompanyGroup = data.data.companyGroup;
          //this.advisoryFirms = data.data.advisoryFirms;
          //this.advisorCustodians = this.model.advisorCustodians;
          //this.loadedAdvisoryFirms = data.data.advisoryFirms;
          //if (this.user.systemLoginType == this.servicer) {
          //    this.loadAdvisoryFirmsForSelectedCompanyGroup(this.selCompanyGroup.id);
          //}

          //if (this.selAdvisorRole.name != this.advisoryAdmin) {
          //    this.showLeadsCombo = true;
          //    this.loadAdvisoryLeads(this.advisor.companyGroup.id);
          //}

        })
        .catch(err => {
          toastr.error("Cannot load advisor " + err.status + " " + err.data);
        })
    }

    mapModel(advisor: domains.IAdvisor): void {
      this.model = this.advisor;
      // console.log("model: ", this.model);

      // An advisor whose login was never created has no systemLogin, and reading a role off it
      // threw here - which is why such a record could not be opened at all, let alone corrected.
      // The screen opens instead with the role left to be chosen, and saving creates the login
      // that is missing. An incomplete record is not a privileged one, so the role restrictions
      // below stay out of the way until there is a role to restrict.
      this.loadedRole = advisor.systemLogin ? advisor.systemLogin.role : null;

      // this.searchrole(this.loadedRole);
      this.selAdvisorRole = this.loadedRole ? { name: this.loadedRole } : null;

      if (this.loadedRole
            && this.user.role === domains.AdvisoryRoles.ADVISORY_LEAD.toString()
            && this.loadedRole != domains.AdvisoryRoles.ADVISORY.toString()) {
        this.getRolesFromIdUser(true);
        this.flagForDisableForm = true;
      }

      if (this.loadedRole
            && this.user.role === domains.AdvisoryRoles.ADVISORY_ADMIN.toString()
            && this.loadedRole != domains.AdvisoryRoles.ADVISORY_LEAD.toString()
            && this.loadedRole != domains.AdvisoryRoles.ADVISORY_ADMIN.toString()
            && this.loadedRole != domains.AdvisoryRoles.ADVISORY.toString()) {
        this.getRolesFromIdUser(true);
        this.flagForDisableForm = true;
      }

      this.model.advisorRole = this.selAdvisorRole ? this.selAdvisorRole.name : null;

      this.selStreetState = <domains.ILOV>{ extra1: this.model.streetState };
      this.selMailingState = <domains.ILOV>{ extra1: this.model.mailingState };
      this.selStreetCountry = <domains.ILOV>{ extra2: this.model.streetCountryId };
      this.selMailingCountry = <domains.ILOV>{ extra2: this.model.mailingCountryId };
      this.streetAddressSameAsMailingAddress = this.model.streetAddressSameAsMailingAddress;

      this.model.companyGroup = advisor.companyGroup;
      this.selCompanyGroup = advisor.companyGroup;
      this.companyGroupId = this.selCompanyGroup.id;
      this.loadedCompanyGroup = advisor.companyGroup;
      this.advisoryFirms = advisor.advisoryFirms;
      this.advisorCustodians.splice(0, this.advisorCustodians.length);
      //console.log("ADVISORCUSTODIANSLOADED", advisor.advisorCustodians);
      //console.log("ADVISORMANAGERSLOADED", advisor.advisorManagers);
        if (advisor.advisorCustodians)
            this.advisorCustodians = advisor.advisorCustodians.filter(p => p.status == domains.RecordStatus.ACTIVE);
      else
        this.advisorCustodians = [];
      this.advisorManagers.splice(0, this.advisorManagers.length);
      if (advisor.advisorManagers)
          this.advisorManagers = advisor.advisorManagers.filter(p => p.status == domains.RecordStatus.ACTIVE);
      else
        this.advisorManagers = [];
      this.loadedAdvisoryFirms = advisor.advisoryFirms;
      if (this.user.systemLoginType == this.servicer) {
        this.loadAdvisoryFirmsForSelectedCompanyGroup(this.selCompanyGroup.id);
      }

      if (!this.selAdvisorRole || this.selAdvisorRole.name != this.advisoryAdmin) {
        this.showLeadsCombo = true;
        this.loadAdvisoryLeads(this.advisor.companyGroup.id);
      }

      this.contactEmailChanged();
    }

    getRolesFromIdUser(getAllRoles: boolean = false): void {
      this.gs.getRoles()
        .then(data => {
            //this.allRoles = data.data;
            this.roles = data.data;
            //if (!getAllRoles) {
            //  this.filterRoles();
            //}
            //else {
            //  this.roles = this.allRoles;
            //}
        })
        .catch(err => {
          toastr.error("Get roles error " + err.status + " " + err.data);
        });
    };


    loadCompanyGroupList(): void {
      this.ss.getCompanyGroups()
        .then(data => {
          this.companyList = data.data;
        })
        .catch(err => {
          toastr.error("Cannot fetch company group list.");
        })
    };


    loadAdvisoryFirmsForSelectedCompanyGroup(companyGroupId: number): void {
        this.advisoryFirmApi.getAdvisoryFirmsByCompanyGroup(companyGroupId)
        .then(data => {
          this.advisoryFirmsRelatedForCompGroup = data.data;
        }, err => {
            toastr.warning("Cannot fetch advisory firms for this company group!");
        })
    }


    companyGroupChanged(): void {

      if (this.model.id > 0 && this.selCompanyGroup.id == this.loadedCompanyGroup.id) {
        this.selCompanyGroup = this.loadedCompanyGroup;
        this.advisoryFirms = this.loadedAdvisoryFirms;
        this.companyGroupId = this.selCompanyGroup.id;
        this.loadAdvisoryLeads(this.companyGroupId);

        this.model.companyGroup = this.selCompanyGroup;
      }
      else {
        this.model.companyGroup = this.selCompanyGroup;

        this.companyGroupId = this.selCompanyGroup.id;

        if (this.selAdvisorRole && this.selAdvisorRole.name != this.advisoryAdmin) {
          this.loadAdvisoryLeads(this.companyGroupId);
          this.showLeadsCombo = true;
        }
        this.advisoryFirms = [];

      }
    }

    advisoryLeads: Array<domains.IAdvisor> = [];

    loadAdvisoryLeads(companyGroupId: number): void {


      if (this.user.systemLoginType != this.servicer) {
        this.ads.getAdvisoryLeadsForCompanyGroup()
          .then(data => {
            this.advisoryLeads = data.data;
            if (this.model.id > 0)
              this.selAdvisoryLead = this.advisoryLeads.filter((v) => { return v.id == this.advisor.selectedAdvisoryLeadId; })[0];


          })
          .catch(err => { toastr.error("Cannot fetch advisory leads!"); })
      }
      else {
          this.advisoryFirmApi.getAdvisoryLeadsForCompanyGroupServicer(companyGroupId)
          .then(data => {
            this.advisoryLeads = data.data;
            if (this.model.id > 0) {
              this.advisoryLeads = data.data.filter((v) => { return v.id != this.model.id; });
              this.selAdvisoryLead = this.advisoryLeads.filter((v) => { return v.id == this.advisor.selectedAdvisoryLeadId; })[0];
            }

          })
          .catch(err => { toastr.error("Cannot fetch advisory leads!"); })
      }
    }


    streetAddressChanged(): void {
      if (this.selStreetState)
        this.model.streetState = this.selStreetState.extra1;
      if (this.selStreetCountry)
        this.model.streetCountryId = this.selStreetCountry.extra2;
      if (this.streetAddressSameAsMailingAddress == true) {
        this.selMailingCountry = this.selStreetCountry;
        this.selMailingState = this.selStreetState;
        this.model.mailingAddress1 = this.model.streetAddress1;
        this.model.mailingAddress2 = this.model.streetAddress2;
        this.model.mailingCity = this.model.streetCity;
        this.model.mailingCountryId = this.model.streetCountryId;
        this.model.mailingPostCode = this.model.streetPostCode
        this.model.mailingState = this.model.streetState;
      }
    }

    equalsAddresses(): void {
      this.streetAddressSameAsMailingAddress = !this.streetAddressSameAsMailingAddress;
      this.flagForZipField = !this.flagForZipField;
      this.selMailingCountry = this.selStreetCountry;
      this.selMailingState = this.selStreetState;
      this.model.mailingAddress1 = this.model.streetAddress1;
      this.model.mailingAddress2 = this.model.streetAddress2;
      this.model.mailingCity = this.model.streetCity;
      this.model.mailingCountryId = this.model.streetCountryId;
      this.model.mailingPostCode = this.model.streetPostCode
      this.model.mailingState = this.model.streetState;
    }


    //filterRoles(): void {

    //  if (this.user.systemLoginType != this.servicer) {
    //    let userRole = this.user.role;

    //      if (userRole == domains.AdvisoryRoles.ADVISORY_ADMIN.toString()) {
    //          // admin can do anything
    //          this.roles = this.allRoles; /*this.allRoles.filter((v) => {
    //              return (v.name === (domains.AdvisoryRoles.ADVISORY_LEAD.toString()))
    //          });*/
    //      } else if (userRole == domains.AdvisoryRoles.ADVISORY_LEAD.toString()) {
    //          // lead can create other leads and advisors 
    //          this.roles = this.allRoles.filter((v) => {
    //              return (v.name === (domains.AdvisoryRoles.ADVISORY.toString())
    //                   || v.name === (domains.AdvisoryRoles.ADVISORY_LEAD.toString())
    //              )
    //          });
    //      } else {
    //          this.roles = [];
    //      }
    //  }
    //  else {
    //    this.roles = this.allRoles;
    //  }
    //}

    itemTracker(item: any, index: number) {
      //console.log("TRACKING ITEM", item);
      var tracker = "";
      if (item.advisoryFirm != null)
        tracker = index + '-' + item.custodianId + '-' + item.advisoryFirm.id;
      else
        tracker = index + '-' + item.custodianId;
      

      return tracker;
    }

    itemTrackerMgr(item: any, index: number) {
      //console.log("TRACKING ITEM", item);
      var tracker = "";
      if (item.advisoryFirm != null)
        tracker = index + '-' + item.managerId + '-' + item.advisoryFirm.id;
      else
        tracker = index + '-' + item.managerId;
      

      return tracker;
    }

    $onInit(): void {

      this.loadLovs();

      this.ids.getUserPromise().then(response => {
        this.user = response;
        this.currentAdvisor = this.user.advisor;
        if (this.user.role != this.advisoryRole && this.user.systemLoginType != domains.SystemLoginType.SERVICER) {
          this.selCompanyGroup = this.currentAdvisor.companyGroup;

          this.showLeadsCombo = true;
          this.loadAdvisoryLeads(this.currentAdvisor.companyGroup.id);
        }

        if (this.user.systemLoginType == domains.SystemLoginType.SERVICER) {
          this.loadCompanyGroupList();
        }
        this.getRolesFromIdUser();
      });
    }

    $onChanges(evt): void {
      for (var key in evt) {
        if (key === "extAdvisorId") {
          if (this.extAdvisorId && this.extAdvisorId > 0) {
            this.loadAdvisor(this.extAdvisorId);
          };
        }
      }
    }

    $routerOnActivate(next, previous) {
      if (next.params.id) {
        this.loadAdvisor(next.params.id);
      }
    }
  }


  class CuAdvisor implements ng.IComponentOptions {

    public bindings: any;
    public controller: any;
    public controllerAs: string;
    public templateUrl: string;
    public $routeConfig: any;

    constructor() {
      this.bindings = {
        $router: "<",
        extAdvisorId: "<",
        advisory: "=",
        companyGroup: "<",
        onAdvisorLoaded: "&"
      };
      this.controller = CuAdvisorController;
      this.controllerAs = "vm";
      this.templateUrl = 'spa/shared/common/cu-advisor.html';
    }
  }
  angular.module(Constants.APP).component("cuAdvisor", new CuAdvisor());
}